import React from 'react'
import { Box } from '@mui/material'
import { VanityUrlInput } from './VanityUrlInput'
import { VanityConventions } from './VanityConventions'
import {
  useDeleteVanityUrl,
  useUpdateCreateVanityUrl,
  useVanityUrlForProductId,
} from 'shared/api/vanityUrls'
import { ConfirmWithDialogButton } from 'shared/ui'

interface VanityUrlProps {
  productId: number
  allowDelete?: boolean
}

export function VanityUrl({ productId, allowDelete = true }: VanityUrlProps) {
  const doCreateOrUpdate = useUpdateCreateVanityUrl(productId)
  const doDelete = useDeleteVanityUrl(productId)
  const [isValidUrl, setIsValidUrl] = React.useState(false)

  const currentUrl: string = useVanityUrlForProductId()(productId)?.URL ?? ''
  const [inputValue, setInputValue] = React.useState(currentUrl)

  const handleUrlChange = React.useCallback(
    (newValue: string, isValid: boolean) => {
      setInputValue(newValue)
      setIsValidUrl(isValid)
    },
    [],
  )

  return (
    <Box>
      <VanityUrlInput
        value={inputValue}
        onChange={handleUrlChange}
        isValid={isValidUrl}
        prompt="Vanity URL"
      />
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <ConfirmWithDialogButton
          onClick={() => doCreateOrUpdate(inputValue)}
          disabled={!isValidUrl || inputValue === currentUrl}
          dialogTitle={`Confirm ${currentUrl ? 'Update' : 'Create'}`}
          dialogContent={`Are you sure you want to ${currentUrl ? 'update' : 'create'} the vanity URL?`}
        >
          Update
        </ConfirmWithDialogButton>
        {currentUrl && allowDelete && (
          <ConfirmWithDialogButton
            onClick={doDelete}
            disabled={inputValue !== currentUrl}
            dialogTitle="Confirm Delete"
            dialogContent="Are you sure you want to delete the vanity URL?"
          >
            Delete
          </ConfirmWithDialogButton>
        )}
      </Box>
      <VanityConventions />
    </Box>
  )
}
